import React from 'react'
import Box from '@material-ui/core/Box'
import { useStyles } from './styles'

const IconBadge = ({ icon: Icon }) => {
  const classes = useStyles()

  return (
    <Box className={classes.iconBadge}>
      <Icon />
    </Box>
  )
}

export default IconBadge
